import React from 'react';

import { IconWrapper } from '..';

export const IconNavigationDownOutline = IconWrapper(
    (
        upperProps: React.SVGProps<SVGSVGElement> & {
            secondaryColor?: string;
        },
    ) => {
        const { secondaryColor, ...props } = upperProps;
        return (
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <mask
                    id="mask0_23351_14122"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="25"
                    height="24"
                >
                    <rect x="0.400391" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_23351_14122)">
                    <path
                        d="M12.4012 14.9499C12.2678 14.9499 12.1428 14.9291 12.0262 14.8874C11.9095 14.8457 11.8012 14.7749 11.7012 14.6749L7.10117 10.0749C6.91784 9.89157 6.82617 9.65824 6.82617 9.3749C6.82617 9.09157 6.91784 8.85824 7.10117 8.6749C7.28451 8.49157 7.51784 8.3999 7.80117 8.3999C8.08451 8.3999 8.31784 8.49157 8.50117 8.6749L12.4012 12.5749L16.3012 8.6749C16.4845 8.49157 16.7178 8.3999 17.0012 8.3999C17.2845 8.3999 17.5178 8.49157 17.7012 8.6749C17.8845 8.85824 17.9762 9.09157 17.9762 9.3749C17.9762 9.65824 17.8845 9.89157 17.7012 10.0749L13.1012 14.6749C13.0012 14.7749 12.8928 14.8457 12.7762 14.8874C12.6595 14.9291 12.5345 14.9499 12.4012 14.9499Z"
                        fill="currentColor"
                    />
                </g>
            </svg>
        );
    },
);
